import { render, staticRenderFns } from "./AccessionTransactions.vue?vue&type=template&id=9f2716ce&scoped=true&"
import script from "./AccessionTransactions.vue?vue&type=script&lang=js&"
export * from "./AccessionTransactions.vue?vue&type=script&lang=js&"
import style0 from "./AccessionTransactions.vue?vue&type=style&index=0&id=9f2716ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2716ce",
  null
  
)

export default component.exports